module.exports = __webpack_public_path__ + "media/images/icons/flags/MT-d11f4338edfcb3779c6e50003f17c302.svg";